export var OrientationType;
(function (OrientationType) {
    /**
     * The orientation is either landscape-primary or landscape-secondary.
     */
    OrientationType["LANDSCAPE"] = "landscape";
    /**
     * The orientation is in the primary landscape mode.
     */
    OrientationType["LANDSCAPE_PRIMARY"] = "landscape-primary";
    /**
     * The orientation is in the secondary landscape mode.
     */
    OrientationType["LANDSCAPE_SECONDARY"] = "landscape-secondary";
    /**
     * The orientation is either portrait-primary or portrait-secondary.
     */
    OrientationType["PORTRAIT"] = "portrait";
    /**
     * The orientation is in the primary portrait mode.
     */
    OrientationType["PORTRAIT_PRIMARY"] = "portrait-primary";
    /**
     * The orientation is in the secondary portrait mode.
     */
    OrientationType["PORTRAIT_SECONDARY"] = "portrait-secondary";
})(OrientationType || (OrientationType = {}));
//# sourceMappingURL=definitions.js.map